import { useMemo } from 'react';

const VIEW_BOX = '0 0 600 320';

function MarkerLines({ markers, center, active }) {
  return (
    <>
      {markers.map((m) => (
        <line
          key={`line-${m.key}`}
          x1={m.x}
          y1={m.y}
          x2={center.x}
          y2={center.y}
          stroke={active === m.key ? 'var(--amber)' : 'rgba(201,148,58,0.4)'}
          strokeWidth={active === m.key ? '2' : '1'}
          strokeDasharray={active === m.key ? '0' : '4,4'}
          style={{ transition: 'all 0.25s' }}
        />
      ))}
    </>
  );
}

function CenterMarker({ m }) {
  return (
    <>
      <circle cx={m.x} cy={m.y} r="9" fill="var(--verde)" />
      <circle cx={m.x} cy={m.y} r="14" fill="none" stroke="var(--verde)" strokeWidth="1" opacity="0.4" />
      <text x={m.x} y={m.y + 28} textAnchor="middle" fontFamily="DM Sans" fontWeight="600" fontSize="11" fill="var(--ink)">
        {m.label}
      </text>
    </>
  );
}

function OriginMarker({ m, isActive }) {
  return (
    <>
      <circle
        cx={m.x} cy={m.y}
        r={isActive ? '8' : '6'}
        fill={isActive ? 'var(--amber)' : '#fff'}
        stroke="var(--amber)"
        strokeWidth="2"
        style={{ transition: 'all 0.2s' }}
      />
      <text x={m.x} y={m.y - 12} textAnchor="middle" fontFamily="DM Sans" fontSize="10" fontWeight={isActive ? '600' : '500'} fill={isActive ? 'var(--ink)' : 'var(--muted)'}>
        {m.label}
      </text>
      {m.km !== undefined && (
        <text x={m.x} y={m.y + 22} textAnchor="middle" fontFamily="DM Sans" fontSize="9" fill="var(--muted)" opacity="0.7">
          {m.km} km
        </text>
      )}
    </>
  );
}

export default function DishMap({ id, map, mapNote, active, onActiveChange }) {
  // Pre-compute origin markers (non-center) once per props change
  const originMarkers = useMemo(
    () => map.markers.filter((m) => !m.center),
    [map.markers],
  );

  return (
    <div className="ddish-map-wrap rv" data-testid={`ddish-${id}-map`}>
      <div className="ddish-map-head">
        <p className="eyebrow">El origen en el mapa</p>
        <p className="copy">{mapNote || 'Mira de dónde viene cada ingrediente.'}</p>
      </div>
      <div className="ddish-map">
        <svg viewBox={VIEW_BOX} xmlns="http://www.w3.org/2000/svg" aria-label="Mapa de orígenes">
          <path
            d="M30,160 Q70,130 140,135 Q200,140 260,120 Q330,95 410,110 Q490,128 560,150 L560,200 Q500,220 430,215 Q360,210 290,225 Q220,240 150,235 Q80,230 30,220 Z"
            fill="rgba(78,124,90,0.08)"
            stroke="rgba(78,124,90,0.25)"
            strokeWidth="1"
          />
          <text x="300" y="55" textAnchor="middle" fontFamily="Playfair Display" fontStyle="italic" fontSize="13" fill="rgba(78,124,90,0.55)">
            Mar Cantábrico
          </text>
          <line x1="40" y1="72" x2="560" y2="72" stroke="rgba(78,124,90,0.18)" strokeDasharray="3,3" />

          <MarkerLines markers={originMarkers} center={map.center} active={active} />

          {map.markers.map((m) => (
            <g
              key={m.key}
              style={{ cursor: m.key && !m.center ? 'pointer' : 'default' }}
              onMouseEnter={() => !m.center && onActiveChange(m.key)}
              onMouseLeave={() => !m.center && onActiveChange(null)}
            >
              {m.center ? <CenterMarker m={m} /> : <OriginMarker m={m} isActive={active === m.key} />}
            </g>
          ))}
        </svg>
      </div>
    </div>
  );
}
